<template>
    <CardContentPanel icon="check-circle" v-bind="{action, index}">
        <template #title>{{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_PREMATURE_PROJECT_COMPLETION.title') }}</template>
        <template #body="{freelancerName}">
            {{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_PREMATURE_PROJECT_COMPLETION.description', {0: freelancerName}) }}
        </template>
        <template #actions>
            <VJoyButton variant="main" size="small" :disabled="!hasAuthorityToEndProject" @click="handleShowDialog">
                {{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_PREMATURE_PROJECT_COMPLETION.action.primary') }}
            </VJoyButton>
        </template>
    </CardContentPanel>
    <EndProjectOverlay v-if="isEndingDialogVisible" all-lots-completed @close:dialog="handleShowDialog" />
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {useUserStore} from '@common/stores';
    import {EndProjectOverlay} from '@features/project-view/ui/common-layout/project-actions';
    import {storeToRefs} from 'pinia';
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'CONFIRM_PREMATURE_PROJECT_COMPLETION'>;
        index: number;
    }>();

    const userStore = useUserStore();
    const {roles, isPlatformAdmin} = storeToRefs(userStore);
    const hasAuthorityToEndProject = computed(() => !isPlatformAdmin.value || roles.value.includes('ROLE_MISSION_VALIDATION'));

    const isEndingDialogVisible = ref(false);

    function handleShowDialog() {
        isEndingDialogVisible.value = !isEndingDialogVisible.value;
    }
</script>
